module.exports = __webpack_public_path__ + "img/amicitia-old.4e664042.jpg";